import { SpaEntityType } from 'shared-types/Spa';
import { compareExtras } from './compareExtras';

export type AdaptedExtra = {
  id: string | number;
  name: string;
  price?: { amount: number; currencyCode: string };
  featured?: boolean;
  image?: { url: string };
  extra?: { id: string | number };
  priority?: number | null;
};

export function adaptSpaExtras(spaEntity: SpaEntityType): AdaptedExtra[] {
  const allExtras: AdaptedExtra[] = [];
  const extras = spaEntity.extras || [];
  extras.forEach((ext: any) => {
    if (ext.options) {
      ext.options.forEach((option: any) => {
        allExtras.push({
          id: option.id,
          name: option.name,
          price: option.price,
          featured: option.featured,
          image: option.image,
          extra: { id: option.id },
          priority: ext.priority ?? null,
        });
      });
    } else {
      allExtras.push({
        id: ext.id,
        name: ext.name,
        price: ext.price,
        featured: ext.featured,
        image: ext.image,
        extra: { id: ext.id },
        priority: ext.priority ?? null,
      });
    }
  });
  return allExtras.sort(compareExtras);
}

export function getExtraId(opt: AdaptedExtra): string | number {
  return opt.extra?.id || opt.id;
}

export function getExtraFieldKey(opt: AdaptedExtra): string {
  return `id-${getExtraId(opt)}`;
}
